import React, { forwardRef } from 'react';
import { ChevronDownIcon } from '@/icons';
import { cn } from '@/utils/mergeClassName';
import * as RadixAccordion from '@radix-ui/react-accordion';

type AccordionTriggerProps = React.ComponentPropsWithoutRef<typeof RadixAccordion.Trigger>;

const AccordionTrigger = forwardRef<
  React.ElementRef<typeof RadixAccordion.Trigger>,
  AccordionTriggerProps
>(({ children, className, ...rest }, ref) => (
  <RadixAccordion.Header className="flex">
    <RadixAccordion.Trigger
      ref={ref}
      className={cn(
        'group flex flex-1 cursor-pointer items-center justify-between text-sm uppercase leading-[1.125rem] tracking-[1px] shadow-[0_-1px_0_0_inset] transition-all',
        className
      )}
      {...rest}
    >
      {children}
      <span
        className="ease-[cubic-bezier(0.87,_0,_0.13,_1)] transition-transform duration-300 group-data-[state=open]:rotate-180"
        aria-hidden
      >
        <ChevronDownIcon />
      </span>
    </RadixAccordion.Trigger>
  </RadixAccordion.Header>
));

const Trigger = AccordionTrigger;

export { type AccordionTriggerProps, AccordionTrigger, Trigger };
